import type { SectionWidgetConfig } from '../../types';
import { SportsWidgetType } from '../../widgets';
import { buildSportsLayoutPageResponse } from '../buildSportsLayoutPageResponse';

import {
  TXTWCL_N0___Ante_Post_Odds_X_Betting,
  TXTWCL_N0___Browse_the_ante_post_odds_ELL
} from './sportsAnimalRacingFutureMarket.messages.json';

const sportsAnimalRacingFutureMarketWidgets = [
  {
    title: 'Sports Ante Post Market Widget',
    _content_type_uid: SportsWidgetType.SportsAntePostMarket
  }
] satisfies readonly SectionWidgetConfig[];

export const sportsAnimalRacingFutureMarket = buildSportsLayoutPageResponse({
  alias: 'sportsAnimalRacingFutureMarket',
  seoConfig: {
    apiPath: '/meta/market/',
    redirectStatusCode: 301,
    redirectTo: 'sportsAnimalRacingFuture',
    descriptionTag: TXTWCL_N0___Browse_the_ante_post_odds_ELL,
    titleTag: TXTWCL_N0___Ante_Post_Odds_X_Betting,
    translationsMap: {
      '0': 'marketName'
    }
  },
  mainSectionWidgetConfigs: sportsAnimalRacingFutureMarketWidgets
});
